export default __webpack_public_path__ + "static/media/coin@3x.75cade2b.png";